// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"13f03e1f","169":"c0185e81","691":"c0185e81"}[chunkId] + ".chunk.css";
};